import { render, staticRenderFns } from "./FormSubmissionsModal.vue?vue&type=template&id=42e2c89e&"
import script from "./FormSubmissionsModal.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports